/**
 * Chat Share Feature Types
 */

export interface SocialMediaPlatform {
  name: string;
  icon: string;
  url: (link: string) => string;
  color: string;
}

export const SOCIAL_MEDIA_PLATFORMS: Record<string, SocialMediaPlatform> = {
  twitter: {
    name: "Twitter",
    icon: "twitter",
    url: (link: string) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`,
    color: "#1DA1F2",
  },
  facebook: {
    name: "Facebook",
    icon: "facebook",
    url: (link: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        link
      )}`,
    color: "#1877F2",
  },
  whatsapp: {
    name: "WhatsApp",
    icon: "whatsapp",
    url: (link: string) => `https://wa.me/?text=${encodeURIComponent(link)}`,
    color: "#25D366",
  },
  linkedin: {
    name: "LinkedIn",
    icon: "linkedin",
    url: (link: string) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        link
      )}`,
    color: "#0A66C2",
  },
};
